/**
 * Convert match scores to FT_1X2 outcome.
 * Used for prediction path: CORRECT_SCORE → FT_1X2 conversion.
 */

/**
 * Get the FT_1X2 outcome from home and away scores.
 *
 * @param home - Home team score
 * @param away - Away team score
 * @returns "1" (home win), "X" (draw), or "2" (away win)
 */
export function getOutcomeFromScores(home: number, away: number): "1" | "X" | "2" {
    if (home > away) {
        return "1";
    }
    if (home < away) {
        return "2";
    }
    return "X";
}

